import { Observable, tap } from "rxjs";
import { AutenticacaoService } from "./autenticacao.service";
import { TipoArmazenamento } from "./modelos/autenticacao-dto";

function limparUrl(url: string): string {
    var url = window.location.toString();

    const novaUrl = new URL(url)

    novaUrl.searchParams.delete('cd');
    novaUrl.searchParams.delete('s');

    return novaUrl.toString();
}

let carregamentoHtml: string = `
<div id="starterLoading" class="e-spinner-pane e-spin-show" style="background: rgba(255, 255, 255, 0.998);position: fixed;z-index: 99999;" 
[style.opacity]="canShow">
    <div _ngcontent-sjk-c10="" class="e-spinner-inner">
        <svg id="YsoYc" class="e-spin-fabric" viewBox="0 0 30 30" 
        style="transform-origin: 15px 15px 15px; height: 30px; width: 30px;    animation: fabric-spinner-rotate 0.3s infinite cubic-bezier(0.53, 0.21, 0.29, 0.67);">
            <path class="e-path-circle" d="M 15 15 m -15 0 a 15 15 0 1 0 30 0 a 15 15 0 1 0 -30 0"></path>
            <path class="e-path-arc" d="M 25.606601717798213 4.3933982822017885 A 15 15 0 0 0 4.393398282201785 4.3933982822017885"></path></svg>
        </div>
    </div>
`

function inserirCarregamento() {
    var template: HTMLTemplateElement = document.createElement('template');
    template.innerHTML = carregamentoHtml.trim();
    document.body.append(template.content.firstChild!);
}

function removerCarregamento() {
    document.getElementById('starterLoading')?.remove();
}

export function iniciarAutenticacao(autenticacao: AutenticacaoService): () => Observable<any> {
    const params = new URLSearchParams(window.location.search);

    let cd  = params.get('cd');
    let s  = params.has('s') ? +(params.get('s') ?? 0) : null;

    window.history.replaceState({}, '', limparUrl(window.location.toString()));

    inserirCarregamento();

    let tipoArmazenamento = TipoArmazenamento.Sessao;

    if(s != null && s >= 0)
        tipoArmazenamento = <TipoArmazenamento>s;

    let ret = () => autenticacao.inicializacao(cd, tipoArmazenamento).pipe(tap(() => { removerCarregamento() }));
    return ret;
}